import React from 'react';
// import './DynamicTable.css'; // optional for styling

export interface ColumnDefinition {
  name: string;
  type: 'string' | 'number' | 'date' | 'boolean';
  isPrimaryKey?: boolean;
}

interface DynamicTableProps {
  columns: ColumnDefinition[];
  data: Record<string, any>[];
}

const DynamicTable: React.FC<DynamicTableProps> = ({ columns, data }) => {
  return (
    <div className="table-responsive custom-scrollbar">
      <table className="table table-bordered ">
        <thead className="thead-dark">
          <tr>
            {columns.map((col) => (
              <th key={col.name}>{col.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center">No data available</td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col) => (
                  <td key={col.name}>
                    {formatValue(row[col.name], col.type)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

function formatValue(value: any, type: ColumnDefinition['type']) {
  if (type === 'boolean') {
    return value ? 'Yes' : 'No';
  }
  if (type === 'date') {
    try {
      const date = new Date(value);
      return isNaN(date.getTime()) ? value : date.toLocaleDateString();
    } catch {
      return value;
    }
  }
  return value;
}

export default DynamicTable;
